























































import Component, {mixins} from 'vue-class-component';
import CurrentLocation from '../../mixins/CurrentLocation';
import BButton from 'buefy/src/components/button/Button.vue';
import {MAFUser} from '@/store/User/types';
import {namespace, State} from 'vuex-class';
import {AddressComponent, PlaceDetailsResult, PlaceSearchResult} from '@google/maps';
import * as firebase from 'firebase/app';
import GeoPoint = firebase.firestore.GeoPoint;
import {HaversineFomula} from '@/store/types';
import * as _ from 'lodash';
import moment from 'moment';
import BTimepicker from 'buefy/src/components/timepicker/Timepicker.vue';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker.vue';
import BClockpicker from 'buefy/src/components/clockpicker/Clockpicker.vue';
import BField from 'buefy/src/components/field/Field.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import {DateTime} from 'luxon';
import {Emit, Prop} from 'vue-property-decorator';
import {Meetup} from '@/store/Friends/types';
import DocumentReference = firebase.firestore.DocumentReference;

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:no-empty */
/* tslint:disable:variable-name */

const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
    components: {
        BField,
        BClockpicker,
        BDatepicker,
        BTimepicker,
        BButton,
        BLoading,
    },
})
export default class MeetUpCreationModal extends mixins(CurrentLocation) {
    @Prop(MAFUser) public invitee!: MAFUser;
    @userNamespace.State('self') public readonly self!: MAFUser;
    @friendNamespace.Action('getPlaces') public getPlaces!: any;
    @friendNamespace.Action('createMeetup') public createMeetup!: any;
    @friendNamespace.Action('sendEmailNotification') public sendEmailNotification!: any;

    public meetups: PlaceSearchResult[];
    public showPlaces: boolean;
    public showDateTime: boolean;
    public date: Date;
    public isLoading: boolean;
    public minDate: Date = DateTime.local().minus({days: 1}).toJSDate();
    public selectedMeetup: PlaceSearchResult | null | undefined;

    constructor() {
        super();
        this.meetups = [];
        this.isLoading = false;
        this.showPlaces = true;
        this.showDateTime = false;
        this.date = DateTime.local().toJSDate();
        this.selectedMeetup = null;
    }
    /* tslint:disable:max-line-length */
    public async submit() {
        if (!this.showPlaces) {
            this.isLoading = true;
            const inviteeRef = await this.$firestore.collection('users').doc(this.invitee.uid);
            const invitee = this.invitee.uid;
            const inviter = this.self.uid;
            const inviterRef = await this.$firestore.collection('users').doc(this.self.uid);
            const when = this.date;
            const where = this.selectedMeetup;
            const confirmed = false;
            const meetUp = new Meetup({
                invitee,
                inviteeRef,
                inviter,
                inviterRef,
                when,
                where,
                confirmed,
            }).toPlainObj();

            await this.createMeetup(meetUp);
            this.sendEmailNotification({to: this.invitee.email, mess: `Hello, ${this.invitee.name}! ${this.self.name} has requested to meetup ${(where) ? 'at ' + where.name : ''} on ${moment(when).format('MM/DD/YYYY hh:mm a')}. Log in and open your Meetups to accept. Please remember to be safe when meeting with someone you don't know, and have fun!`});
            this.isLoading = false;
        }
        this.close();
    }
    @Emit('close')
    public close() {
    }
    public async created() {
        this.isLoading = true;
        const query = this.invitee.comparison &&
            this.invitee.comparison.matchedInterests.length ?
            this.invitee.comparison.matchedInterests[0] : 'restaurant';

        if (this.self.location || this.invitee.location) {
            // @ts-ignore
            const lat = this.self.location ? this.self.location.latitude : this.invitee.location.latitude;
            // @ts-ignore
            const lng = this.self.location ? this.self.location.longitude : this.invitee.location.longitude;
            this.meetups = await this.getPlaces({query, lat, lng, radius: 20});
        }
        this.isLoading = false;

    }

    get formatDate() {
        return DateTime.fromJSDate(this.date).toFormat('cccc, LLLL d / t');
    }

    public selectMeetup(mu: PlaceSearchResult) {
        this.selectedMeetup = mu;
        this.showPlaces = false;
        this.showDateTime = true;
    }

    get MyMeetups() {
        const myLoc = this.convertMyLocToGeoPoint();
        const ret: any = [];
        _.forEach(this.meetups, (mu) => {
            const myMeetup: any = {mu};
            if (myLoc && mu.geometry && mu.geometry.location) {
                myMeetup.distance =
                    new HaversineFomula(
                        myLoc, new GeoPoint(mu.geometry.location.lat, mu.geometry.location.lng),
                    ).distance;

            } else {
                myMeetup.distance = 0;
            }
            ret.push(myMeetup);
        });
        return _.sortBy(ret, ['distance']);
    }

    public distance(distance: number) {
        return `${(distance / 5280).toFixed(2)} mi away`;
    }

    public address(res: PlaceDetailsResult): string {
        let street_number = '';
        let street = '';
        for (const comp of res.address_components) {
            if (comp.types.includes('street_number')) {
                street_number = comp.long_name;
            }
            if (comp.types.includes('route')) {
                street = comp.long_name;
            }
        }
        return `${street_number} ${street}`;
    }

    public selectedCity(res: PlaceDetailsResult): string {
        let city = '';
        let state = '';
        for (const comp of res.address_components) {
            if (comp.types.includes('locality')) {
                city = comp.long_name;
            }
            if (comp.types.includes('administrative_area_level_1')) {
                state = comp.long_name;
            }
        }

        return `${city}, ${state}`;
    }

    public city(res: PlaceDetailsResult): string {
        let city = '';
        let state = '';
        let zip = '';

        for (const comp of res.address_components) {
            if (comp.types.includes('locality')) {
                city = comp.long_name;
            }
            if (comp.types.includes('administrative_area_level_1')) {
                state = comp.long_name;
            }
            if (comp.types.includes('postal_code')) {
                zip = comp.long_name;
            }
        }
        return `${city}, ${state} ${zip}`;
    }

}
